import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "@lib/i18n";
import { bool, oneOfType, shape, string } from "prop-types";
import { getIsVehicleRegistrationByCitroenSelected } from "@shared/v2/lib/getIsVehicleRegistrationByCitroenSelected";
import { getFormattedPrice } from "@shared/v2/lib/getFormattedPrice";

import {
  useConfigurationSelector,
  useCurrencySettingsSelector,
} from "@redux/reducers/appConfig";

import CarteGriseDetail from "./CarteGriseDetail";
import Typography from "../shared/Typography";
import { dealType } from "@types";

const CitroenRegistration = ({ deal, isFinance, registrationType }) => {
  const { t } = useTranslation();

  const configuration = useConfigurationSelector();

  const selfRegistrationPrice =
    configuration.app.solJourney.cashJourney?.vehicleRegistration
      ?.selfRegistration?.price;

  const currency = useCurrencySettingsSelector();

  return (
    <motion.div
      initial="open"
      animate={
        getIsVehicleRegistrationByCitroenSelected(registrationType)
          ? "open"
          : "collapsed"
      }
      exit="collapsed"
      variants={{
        open: {
          opacity: 1,
          height: "auto",
          display: "block",
        },
        collapsed: {
          opacity: 0,
          height: 0,
          transitionEnd: { display: "none" },
        },
      }}
    >
      <div className="pl-10 pr-3 flex flex-col items-start gap-2">
        {!isFinance && (
          <Typography className="text-sm">
            {t("basket.vehicleRegistration.optionCitroen.details")}
          </Typography>
        )}
        <Typography className="text-sm mt-2">
          {t("basket.vehicleRegistration.optionCitroen.sendDocuments", {
            price: getFormattedPrice(
              selfRegistrationPrice,
              currency.format,
              currency.symbol
            ),
          })}
        </Typography>
        <CarteGriseDetail deal={deal} />
      </div>
    </motion.div>
  );
};

CitroenRegistration.propTypes = {
  deal: dealType.isRequired,
  isFinance: bool,
  registrationType: oneOfType([string, shape({ type: string })]),
};

export default CitroenRegistration;
